export class FileCommand {
    formData: FormData;

    constructor(formProperty: string, file: File | Blob, fileName: string = file instanceof File ? file.name : '') {
        this.formData = new FormData();

        this.formData.append(formProperty, file, fileName);
    }
}
